import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useT from "../../i18n/useT";
import core from "../../core";

const ActivityLog = () => {
    const t = useT();
    const role = useSelector((state) => state.user.role);
    const isStaff = role === "admin" || role === "moderator";

    const [rows, setRows] = useState([]);
    const [actions, setActions] = useState([]);
    const [filter, setFilter] = useState({ action: "", from: "", to: "" });

    useEffect(() => {
        if (!isStaff) return;
        axios.get("/api/activity-log/actions").then((res) => setActions(res.data.data || [])).catch(() => {});
    }, [isStaff]);

    useEffect(() => {
        if (!isStaff) return;
        const q = [];
        if (filter.action) q.push(`action=${encodeURIComponent(filter.action)}`);
        if (filter.from) q.push(`from=${filter.from}`);
        if (filter.to) q.push(`to=${filter.to}`);
        axios.get("/api/activity-log" + (q.length ? "?" + q.join("&") : "")).then((res) => setRows(res.data.data || [])).catch(() => {});
    }, [isStaff, filter]);

    if (!isStaff) {
        return <div className="page-content-main-container"><h2 className="page-title">{t("activity.title")}</h2></div>;
    }

    return (
        <div className="page-content-main-container">
            <h2 className="page-title">{t("activity.title")}</h2>

            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", alignItems: "flex-end", marginBottom: "16px" }}>
                <div>
                    <label style={{ fontSize: "12px", opacity: 0.7, display: "block" }}>{t("activity.action")}</label>
                    <select className="form-control" style={{ width: "auto" }} value={filter.action} onChange={(e) => setFilter((p) => ({ ...p, action: e.target.value }))}>
                        <option value="">{t("activity.allActions")}</option>
                        {actions.map((a) => <option key={a} value={a}>{a}</option>)}
                    </select>
                </div>
                <div>
                    <label style={{ fontSize: "12px", opacity: 0.7, display: "block" }}>{t("activity.from")}</label>
                    <input type="date" className="form-control" value={filter.from} onChange={(e) => setFilter((p) => ({ ...p, from: e.target.value }))} />
                </div>
                <div>
                    <label style={{ fontSize: "12px", opacity: 0.7, display: "block" }}>{t("activity.to")}</label>
                    <input type="date" className="form-control" value={filter.to} onChange={(e) => setFilter((p) => ({ ...p, to: e.target.value }))} />
                </div>
                {(filter.action || filter.from || filter.to) && <button className="btn btn-sm btn-outline-secondary" onClick={() => setFilter({ action: "", from: "", to: "" })}>{t("activity.clear")}</button>}
            </div>

            {rows.length === 0 ? (
                <div style={{ opacity: 0.6 }}>{t("activity.none")}</div>
            ) : (
                <div style={{ overflowX: "auto" }}>
                    <table className="table" style={{ width: "100%" }}>
                        <thead>
                            <tr>
                                <th>{t("activity.date")}</th>
                                <th>{t("activity.user")}</th>
                                <th>{t("activity.role")}</th>
                                <th>{t("activity.action")}</th>
                                <th>{t("activity.entity")}</th>
                                <th>{t("activity.details")}</th>
                                <th>{t("activity.ip")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((r) => (
                                <tr key={r.id}>
                                    <td style={{ fontSize: "12px", whiteSpace: "nowrap" }}>{r.created_at ? core.formdatDate(r.created_at, "dd-mm-yyyy") : "—"}</td>
                                    <td>{r.username || r.user_id || "—"}</td>
                                    <td style={{ fontSize: "12px" }}>{r.role || "—"}</td>
                                    <td><code style={{ fontSize: "12px" }}>{r.action}</code></td>
                                    <td style={{ fontSize: "12px" }}>{r.entity ? `${r.entity}${r.entity_id ? " #" + r.entity_id : ""}` : "—"}</td>
                                    <td style={{ fontSize: "12px" }}>{r.details || "—"}</td>
                                    <td style={{ fontSize: "11px", opacity: 0.6 }}>{r.ip || "—"}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default ActivityLog;
